module.exports = __webpack_public_path__ + "img/1497578824.0fab74b7.jpg";